import React from "react";
import  "../PostPayment.scss";
import {PostPaymentItem} from "../item/PostPaymentItem";
import {CallForHelpLink} from "../../../../../app/tileable/instructions/contats/CallForHelpLink";
import {EmailForHelpLink} from "../../../../../app/tileable/instructions/contats/EmailForHelpLink";
import {LoanData} from "../../../../loan-details/model/LoanData";
import {LoanTypeUtil} from "../../../../../util/LoanTypeUtil";
import {PaymentResult} from "../../../../../stripe/model/PaymentResult";
import {StripeErrorMapper} from "../../../../../stripe/util/StripeErrorMapper";

interface Props {
    loan: LoanData
    result: PaymentResult
}

export class PostPaymentNote extends React.Component<Props> {

    render() {
        let support = this.props.loan.support;
        let result = this.props.result;
        if (this.isPending(result)) {
            return (
                <PostPaymentItem id="payment-summary-note">
                    <span>
                        Please wait a few minutes while we process your payment.
                        You can keep this page open; it will update once your payment is confirmed.
                        As always, <CallForHelpLink support={support}>call</CallForHelpLink> or <EmailForHelpLink
                        support={support}>email</EmailForHelpLink> {this.supportAgent()} if you have any questions.
                    </span>
                </PostPaymentItem>
            );
        }
        if (result.paid === false) {
            return (
                <PostPaymentItem id="payment-summary-note">
                    <span>
                        {StripeErrorMapper.mapAchFailureCode(result.failureCode, result.failureMessage)}
                        As always, <CallForHelpLink support={support}>call</CallForHelpLink> or <EmailForHelpLink
                        support={support}>email</EmailForHelpLink> {this.supportAgent()} if you have any questions.
                    </span>
                </PostPaymentItem>
            );
        }
        if (result.paid === true) {
            return (
                <PostPaymentItem id="payment-summary-note">
                        <span>
                            You're all set.
                            You should receive an email confirmation to the same email you used to manage your loan process.
                            You can print this page, and please keep your confirmation email for your records.
                            As always, <CallForHelpLink support={support}>call</CallForHelpLink> or <EmailForHelpLink
                            support={support}>email</EmailForHelpLink> {this.supportAgent()} if you have any questions.
                        </span>
                </PostPaymentItem>
            );
        }

        // Fallback: should not happen, but show processing message
        return (
            <PostPaymentItem id="payment-summary-note">
                <span>
                    Please wait a few minutes while we process your payment.
                    You can keep this page open; it will update once your payment is confirmed.
                    As always, <CallForHelpLink support={support}>call</CallForHelpLink> or <EmailForHelpLink
                    support={support}>email</EmailForHelpLink> {this.supportAgent()} if you have any questions.
                </span>
            </PostPaymentItem>
        );
    }

    private supportAgent = () => LoanTypeUtil.supportAgentOf(this.props.loan);

    private isPending = (result: PaymentResult): boolean => {
        if (result.paid === null) {
            return true;
        }
        const hasFailureMessage = result.failureMessage != null && result.failureMessage.length > 0;
        const hasFailureCode = result.failureCode != null && result.failureCode.length > 0;
        const hasErrorParams = result.errorParams != null;
        return !result.paid && !hasFailureMessage && !hasFailureCode && !hasErrorParams;
    };
}
